export default __webpack_public_path__ + "static/media/Fellblade of Crimson Slaughter.f12170bc.jpg";